import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStockItemType implements BaseEnumType {
  private static allValues: EnumStockItemType[] = []; // make sure this is top-most
  
  public static unknown = new EnumStockItemType(0, "Unknown", "enum_stock_item_type_unknown");
  public static material = new EnumStockItemType(1, "Material", "enum_stock_item_type_material");
  public static product = new EnumStockItemType(2, "Product", "enum_stock_item_type_product");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStockItemType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumStockItemType.unknown; }
  public isMaterial() { return this === EnumStockItemType.material; }
  public isProduct() { return this === EnumStockItemType.product; }

  public static getValues(): readonly EnumStockItemType[] {
    return EnumStockItemType.allValues;
  }

  public static getValuesExcept0(): readonly EnumStockItemType[] {
    return EnumStockItemType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStockItemType {
    const found = EnumStockItemType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStockItemType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStockItemType): EnumStockItemType {
    const found = name ? EnumStockItemType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStockItemType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStockItemType>): boolean {
    return this.key === other?.key;
  }
}